import React from "react";
import PropTypes from "prop-types";
import isArray from "lodash/isArray";

function SelectOptions({options}) {

    if (isArray(options)) {
        return options.map((opt, index) => (
            <option key={index} value={opt.value}>{opt.label}</option>
        ));
    }

    return Object.keys(options).map((group, index) => (
        <optgroup key={index} label={group}>
            <SelectOptions options={options[group]} />
        </optgroup>
    ));
}

SelectOptions.defaultProps = {
    options: [],
};

SelectOptions.propTypes = {
    options: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
    ]).isRequired
};

export default SelectOptions;
